<template>
	<div>
		<errorHeader></errorHeader>
		<div class="emtpy">
			<img src="../assets/emtpy.png"  class="emtpy_img" alt="">
			<div class="desc">
				<img src="../assets/tishi.png" alt="" class="desc_img">
				<div>{{TOAST_INFO}}</div>
			</div>
		</div>
		<copyFooter color="#000"></copyFooter>
	</div>
</template>
<script>
	import {mapMutations,mapActions,mapState} from  'vuex'
	import errorHeader from '../components/errorHeader.vue'
	import copyFooter from '../components/copyFooter.vue'
	export default {
		data() {
			return {
			
			}
		},
		created() {
			
		},
		components: {
			copyFooter,
			errorHeader
		},
		methods: {
			...mapMutations(['SET_TOAST'])
		},
		computed: {
			...mapState(['TOAST_INFO'])
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.emtpy {
		display: flex;
		flex-direction: column;
		align-items: center;
		.emtpy_img {
			width: 700px;
			margin-top: 15px;
		}
		.desc{
			font-family: PingFang SC;
			font-weight: 400;
			height: 89px;
			background-color: #E8E8E8;
			display: flex;
			align-items: center;
			font-size: 18px;
			position: absolute;
			bottom: 100px;
			div{
				text-overflow: ellipsis;
				overflow: hidden;
				display: block;
				width: 800px;
				white-space: nowrap;
			}
			padding: 0px 24px;
			color: #999999;
			.desc_img{
				width: 34px;
				height: 35px;
				margin-right: 19px;
			}
		}
		

	}
</style>
